// extracted by mini-css-extract-plugin
export default {"imageWrapper":"tJ-z","twoColumnImage":"uJ-z"};